import * as React from 'react';
import M from "materialize-css";
import { baseLogin } from '../Config/Config';
import { redirect, useNavigate, useMatches,useParams } from 'react-router-dom';
import axios from 'axios';
export default function PasswordReset() {
  const [password, setPassword] = React.useState("");
  const [email, setEmail] = React.useState("");
  const navigate = useNavigate()
 

  const loginUser = () => {
   
    axios.post(`${baseLogin}api/reset-pass/`, {
      "email":email,
      "password":password
    })
      .then((res) => {
        navigate("/")
        M.toast({
          html:"password o'zgardi!" ,
          classes: "#00e676 green accent-3",
        });

      })
      .catch((error) => {
        console.log(error.response);
        if(error.response && error.response.data){
          if(error.response.data['detail']){
            M.toast({
              html: error.response.data['detail'],
              classes: "#00e676 red accent-3",
            });
          } else if(error.response.data['error']){
            var txt = ""
            if(Array.isArray(error.response.data['error'])){
              error.response.data['error'].forEach(element => {
                txt +=`${element}<br>`
              });
            } else {
              txt = error.response.data['error'];
            }
            M.toast({
              html: txt,
              classes: "#00e676 red accent-3",
            });
          } else if(error.response.data['password']){
            var txt = ""
            error.response.data['password'].forEach(element => {
              txt +=`${element}<br>`
            });
            M.toast({
              html: txt,
              classes: "#00e676 red accent-3",
            });
          } else {
            M.toast({
              html: "Xatolik yuz berdi!",
              classes: "#00e676 red accent-3",
            });
          }
        } else {
          M.toast({
            html: "Tarmoq xatosi!",
            classes: "#00e676 red accent-3",
          });
        }
      });
  };
  return (
    <div className='password'>
      <div className='kirish'>
        <div className='box'>
      <form>
      <label >Email:</label>
        <input
          name="email"
          type="email"
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label >Yangi parol:</label>
        <input
          name="password"
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </form>
      <button className="btn" onClick={() => loginUser()}>
          Passwordni o'zgartirish
        </button>
        </div>
        </div>
    </div>
  );
};